import { City } from '../../api/models/locations';
import { CITIES_CACHE_TTL, CITIES_CACHE_KEY, CITIES_CACHE_VERSION } from '../constants';

interface CitiesCacheData {
  cities: City[];
  timestamp: number;
  version: number;
}

export const getCachedCities = (): City[] | null => {
  try {
    const cachedData = localStorage.getItem(CITIES_CACHE_KEY);
    if (!cachedData) return null;

    const parsedData: CitiesCacheData = JSON.parse(cachedData);

    // Check version and remove if outdated
    if (parsedData.version !== CITIES_CACHE_VERSION) {
      localStorage.removeItem(CITIES_CACHE_KEY);
      return null;
    }

    // Check if cache has expired
    if (Date.now() - parsedData.timestamp > CITIES_CACHE_TTL) {
      localStorage.removeItem(CITIES_CACHE_KEY);
      return null;
    }

    return parsedData.cities;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error reading cities from cache:', error);
    return null;
  }
};

export const setCachedCities = (cities: City[]): void => {
  try {
    const cacheData: CitiesCacheData = {
      cities,
      timestamp: Date.now(),
      version: CITIES_CACHE_VERSION
    };
    localStorage.setItem(CITIES_CACHE_KEY, JSON.stringify(cacheData));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error caching cities:', error);
  }
};
